<script setup>
import {useStore} from "vue2-helpers/vuex";
import {getLogo} from "@/helpers/logo";
import Vue from "vue";

const {user, location} = defineProps(['user', 'location']);
const store = useStore();

function createChatRoom() {
    const recipient = {
        "type": "user",
        "company": store.state.user.company_name,
        "company_type": "enterprise",
        "id": user.id,
        "name": user.name,
        "job_title": "co-pace - Managing Director",
        "logo": user.avatar ? user.avatar : getLogo(store.state.user.company_logo)
    };

    store.dispatch('openOrCreateChat', [recipient]);
}

function copyEmail() {
    navigator.clipboard.writeText(user.email)
        .then(() => {
            Vue.notify({
                group: 'app',
                type: 'success',
                duration: 2000,
                text: "Email copied to clipboard!"
            })
        })
}
</script>

<template>
    <li>
        <p class="list-community__location">
            <template v-if="location">
                <span v-html="location"></span>
            </template>
            <template v-else-if="user.location">
                <span v-html="user.location"></span>
            </template>
            <template v-else>
                &nbsp;
            </template>
        </p>

        <b-dropdown :disabled="user.id === store.state.user.id || user.id === 0" class="dropdown-small" variant="link" no-caret>
            <template #button-content>
                <img :src="user.avatar ? user.avatar : require('@/images/icon-light-user.svg')" alt="">

                <p>{{ user.name }}</p>
            </template>

            <b-dropdown-item class="link-message"
                @click="createChatRoom"
            >
                Open Chat
            </b-dropdown-item>
            <b-dropdown-item class="link-envelope-inline">
                <a
                    :href="`mailto:${user.email}`"
                    class="email-link"
                    @click.stop
                >
                    {{ user.email }}
                </a>
                <span class="copy-email" @click.stop.prevent="copyEmail"></span>
            </b-dropdown-item>
        </b-dropdown>
        
        
    </li>
</template>

<style scoped>
    .copy-email {
        padding-right: 23px;
        background: url(../../../../../images/icon-copy-light.svg) no-repeat;
        background-size: 15px;
        background-position-y: top;
        background-position-x: right;
    }
</style>
